$(document).ready(function() {
	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	$('#projects').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.prev-proj').click(function() {
		$('#projects').slick('slickPrev');
		return false;
	});

	$('.next-proj').click(function() {
		$('#projects').slick('slickNext');
		return false;
	});

	// reviews

	$('#reviews').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		autoplaySpeed: 3000,
		centerMode: true,
		centerPadding: '0%',
		rtl: dirRtlFlag,
		responsive: [{
			breakpoint: 993,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}]
	});

	$('.prev-reviews').click(function() {
		$('#reviews').slick('slickPrev');
		return false;
	});

	$('.next-reviews').click(function() {
		$('#reviews').slick('slickNext');
		return false;
	});


})